module.exports = __webpack_public_path__ + "static/img/alipay.511e22ff.svg";